import React, { useEffect, useState } from 'react';
import api from '../utils/api'; // Pastikan untuk menyesuaikan dengan path API Anda
import './styles/Kidola.css';

const StudentListPopup = ({ onSelectStudent, onClose, branchId }) => {
    const [students, setStudents] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0);


    useEffect(() => {
        handleSearch();
    }, [currentPage]);

    const handleSearch = async () => {
        try {
            const response = await api.post('/student/getStudentListPopup', {
                data: [{
                    student_name: searchName,
                    branch_id: branchId,
                }],
                limit: 25, 
                page: currentPage 
            });
            setStudents(response.data.data.studentList);
            setTotalData(response.data.data.totalCount); 
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); 

            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 25));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }
        } catch (error) {
            console.error("Failed to fetch students", error);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    return (
        <div className="popup">
            <h2>Student List</h2>
            <div className="search-container">
                <input 
                type="text" 
                placeholder="Search Student" 
                value={searchName} 
                onChange={(e) => setSearchName(e.target.value)} 
                />
                <button onClick={handleSearch}>Search</button>
            </div>
            <div className="teachers-list">
                <table>
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Student Name</th>
                            <th>NIK</th>
                            <th>Branch</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.map((student, index) => (
                            <tr key={student.student_id} onClick={() => onSelectStudent(student)}>
                                <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                <td>{student.student_name}</td>
                                <td>{student.student_code}</td>
                                <td>{student.Branch ? student.Branch.branch_name : ""}</td>
                                <td>
                                    <button onClick={() => onSelectStudent(student)}>Select</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className="total-data">
                <span>Total Data: {totalData}</span>
            </div>
            <div className="pagination">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                    Prev
                                </button>
                            </td>
                            <td>
                                <span>Page {currentPage} of {totalPages}</span>
                            </td>
                            <td>
                                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="search-container">
                <button className="close-button" onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default StudentListPopup;
